var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMyKakao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.339355,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#F9E001"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.08984C7.05 4.08984 3 7.23984 3 11.1398C3 13.6398 4.65 15.8398 7.2 17.0898L6.35 20.2398C6.3 20.3398 6.35 20.4398 6.4 20.4898C6.45 20.5398 6.5 20.5898 6.6 20.5898C6.65 20.5898 6.7 20.5898 6.75 20.5398L10.4 18.0898C10.95 18.1898 11.5 18.1898 12 18.1898C16.95 18.1898 21 15.0398 21 11.1398C21 7.23984 16.95 4.08984 12 4.08984Z",
    fill: "#3C1D1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMyKakao);
export default __webpack_public_path__ + "static/media/ic_my_kakao.295204335d8f49cadf613c6be021f418.svg";
export { ForwardRef as ReactComponent };